<div>
    <mat-slide-toggle [(ngModel)]="scanMgr.allowKeyboard">Allow All Virtual Keyboard</mat-slide-toggle>
</div>
<!-- <div>
    <mat-slide-toggle [(ngModel)]="scanMgr.allowNumericKeyboard">Allow Numeric Virtual Keyboard</mat-slide-toggle>
</div> -->
<div>
    <mat-slide-toggle [(ngModel)]="!logging.enabled">Disable Backend Server Logging</mat-slide-toggle>
</div>
<div>
    <mat-slide-toggle [(ngModel)]="acumatica.logAPIRequests">Log Acumatica APIs to Console</mat-slide-toggle>
</div>
<div style="padding-left:2.5em;">
    <mat-slide-toggle [(ngModel)]="acumatica.logAPIRequestsInJSON" [disabled]="!acumatica.logAPIRequests">include JSON
        in Console
    </mat-slide-toggle><br />

    <mat-slide-toggle [(ngModel)]="acumatica.logAPIRequestsToBackend"
        [disabled]="!acumatica.logAPIRequests || !logging.enabled">Log to
        Backend Server
    </mat-slide-toggle>
</div>
<div>
    <mat-slide-toggle [(ngModel)]="acumatica.disableAdjustmentRelease">Disable Picking Adjustment Release
    </mat-slide-toggle>
</div>
<div>
    <mat-slide-toggle [(ngModel)]="acumatica.cacheAPIResponses">Use Caching</mat-slide-toggle>
</div>
<div>
    <mat-slide-toggle [(ngModel)]="DirtyNavProtectionDisabled">Disable Dirty Nav Protection
    </mat-slide-toggle>
</div>

<mat-form-field appearance="fill">
    <mat-label>Override Rep Whse ID</mat-label>
    <input matInput [(ngModel)]="OverrideRepWhseID" />
    <mat-hint>Include prefix "REP-..." or blank for no override</mat-hint>
</mat-form-field>